import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "levels-description__item-text" }
const _hoisted_2 = { class: "levels-description__item-tooltip-trigger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ElTooltip = _resolveComponent("ElTooltip")!

  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({ height: _ctx.height }),
    class: "levels-description__wrapper"
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedDetails, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.id,
        class: _normalizeClass([_ctx.getItemClasses(item), "levels-description__item"])
      }, [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.getItemText(item)), 1),
        (_ctx.itemHasLongText(item))
          ? (_openBlock(), _createBlock(_component_ElTooltip, {
              key: 0,
              content: item.achievements,
              enterable: false,
              placement: "top",
              "popper-class": "levels-description__item-tooltip el-abaca-tooltip"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("common.more")), 1)
              ]),
              _: 1
            }, 8, ["content"]))
          : _createCommentVNode("", true)
      ], 2))
    }), 128))
  ], 4))
}